<template>
    <div ref="dialog" :style="style" class="v-toolinline" @click.prevent="" @keypress.esc="$emit('cancel')" tabindex="0">
        <div class="v-toolinline__content">
            <div class="margin-bottom-medium">
                <slot name="message">Hier könnte Ihre Meldung stehen!</slot>
            </div>
            <div class="v-toolinline__options" v-if="options">
                <div v-if="yesno">
                    <div class="row">
                        <div class="col-xs-12 col-sm-6">
                            <button @click.prevent.stop="$emit('ok')" class="st-btn st-btn--small" :class="positiveBtnClass"><slot name="positive">{{ $t('Confirm') }}</slot></button>
                        </div>
                        <div class="col-xs-12 col-sm-6 text-right">
                            <button @click.prevent.stop="$emit('cancel')" class="st-btn st-btn--small st-btn--cancel"><slot name="negative">{{ $t('Cancel') }}</slot></button>
                        </div>
                    </div>
                </div>
                <div v-if="!yesno">
                    <div class="text-right">
                        <a @click.prevent.stop="$emit('cancel')" class="st-btn st-btn--small st-btn--close"><slot name="negative">{{ $t('Close') }}</slot></a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
export default {
  	name: 'v-toolinline',
	props: {
		type: {
		  type: String,
		  default: 'submit'
		},
		options: {
		  type: Boolean,
		  default: true
		},
		yesno: {
		  type: Boolean,
		  default: false
		},
		loading: {
		  type: Boolean,
		  default: false
		}
	},
	computed: {
		positiveBtnClass(){
			const classname = 'st-btn--' + this.type;

			return [
				classname,
				{
					'st-btn--loading': this.loading
				}
			];
		},
		style(){
			return 'top: ' + this.y +'px; left: '+ this.x +'px;';
		}
	}
}
</script>

<style lang="scss">
.v-toolinline {
	&__options{
		position: absolute;
	}
	.row {
		padding: 0;
		display: block;
	}
	.st-btn {
		display: block;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/v-toolinline.vue